module.exports = __webpack_public_path__ + "img/minusIcon.b32583ba.svg";